module.exports = {
	"description": "Card image component",
	"methods": []
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-docgen-loader!./src/Card/CardImage.js
// module id = 1546
// module chunks = 0